<template>
  <div>
    <v-dialog v-if="userQuestionnaireDialog" v-model="userQuestionnaireDialog" max-width="75%" persistent>
      <questionAnswersFilter
        :inAnswers=selectedInAnswerIds
        :notInAnswers=selectedNotInAnswerIds
        @cancel="questionAnswersCancel"
        @submit="questionAnswersSubmit"
      >
      </questionAnswersFilter>
    </v-dialog>
    <v-overlay :value="loadingUsers" absolute>
        <!-- <v-progress-circular
          indeterminate
          color="primary"
          size="250"
        ></v-progress-circular> -->
      <v-card :loading="loadingUsers" color="primary">
        <template slot="progress">
          <v-progress-linear
            color="white"
            height="5"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Loading Users...</v-card-title>
      </v-card>
    </v-overlay>

    <v-expansion-panels v-model="userSearchPanelModel" multiple>
      <v-expansion-panel :key="userFilterPanel">
        <v-expansion-panel-header>
          <div class="headline">Filter Users</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form>
            <v-container>
              <v-row justify="space-around">
                <v-flex xs12 sm6 md5>
                  <!-- <v-layout wrap> -->
                    <!-- <v-flex xs12 lg8>
                      <v-text-field
                        v-model="numSavingGoals"
                        append-icon="search"
                        label="Number of Saving Goals"
                        persistent-hint
                        hide-details
                        clearable=""
                        type="number"
                      ></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex xs12 lg4>
                      <v-select
                        v-model="savingGoalComparison"
                        :items="savingGoalComparisonOption"
                        label="Comparison"
                        return-object
                      ></v-select>
                    </v-flex> -->
                  <!-- </v-layout>
                  <v-select
                    v-model="selectedJarCategories"
                    :items="jarCategories"
                    :item-text="
                      (item) => item.categoryId + ' - ' + item.categoryName
                    "
                    label="Jar Categories"
                    required="!broadcast"
                    multiple
                    presistent-hint
                    return-object
                  >
                  </v-select>
                  <v-text-field
                    v-model="savingGoalsName"
                    append-icon="search"
                    label="Name of Saving Goals"
                    single-line
                    hide-details
                    clearable=""
                  ></v-text-field>

                  <v-menu
                    v-model="signOnDateMenu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="315px"
                    class="ma-0"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="displaySignOnDate"
                        label="Login Date"
                        persistent-hint
                        class="mr-2"
                        append-icon="event"
                        readonly
                        v-on="on"
                        required
                        clearable
                        @click:clear="signOnDate = null; signOnComparison = 'After'"
                        @click="openSignOnDate"
                      ></v-text-field>
                    </template>
                    <v-card class="ma-0" @keydown.esc="cancelSignOnDate">
                      <v-container class="ma-0">
                        <v-row>
                          <v-col>
                            <v-date-picker
                              v-model="signOnDate"
                              color="primary"
                              class="ma-0 pa-0"
                              elevation="0"
                              flat
                            >
                            </v-date-picker>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-select
                                class="ma-0 pa-0"
                                v-model="signOnDateComparison"
                                :items="signOnDateComparisonOption"
                                label=""
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="1"></v-col>
                          <v-col cols="5">
                            <v-btn
                              class="mr-1"
                              outlined
                              small
                              fab
                              color="red"
                              @click="cancelSignOnDate"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                              class="ml-1 mr-0 mt-0"
                              outlined
                              small
                              fab
                              color="green"
                              @click="confirmSignOnDate"
                            >
                              <v-icon>mdi-check-bold</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-menu>
                  <v-menu
                    v-model="createdDateMenu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="315px"
                    class="ma-0"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="displayCreatedDate"
                        label="Created Date"
                        persistent-hint
                        class="mr-2"
                        append-icon="event"
                        readonly
                        v-on="on"
                        required
                        clearable
                        @click:clear="createdDate = null; createdDateComparison = 'After'"
                        @click="openCreatedDate"
                      ></v-text-field>
                    </template>
                    <v-card class="ma-0" @keydown.esc="cancelCreatedDate">
                      <v-container class="ma-0">
                        <v-row>
                          <v-col>
                            <v-date-picker
                              v-model="createdDate"
                              color="primary"
                              class="ma-0 pa-0"
                              elevation="0"
                              flat
                            >
                            </v-date-picker>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-select
                              class="ma-0 pa-0"
                              v-model="createdDateComparison"
                              :items="createdDateComparisonOption"
                              label=""
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="1"></v-col>
                          <v-col cols="5">
                            <v-btn
                              class="mr-1"
                              outlined
                              small
                              fab
                              color="red"
                              @click="cancelCreatedDate"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                              class="ml-1 mr-0 mt-0"
                              outlined
                              small
                              fab
                              color="green"
                              @click="confirmCreatedDate"
                            >
                              <v-icon>mdi-check-bold</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-menu>
                  <v-text-field
                    readonly
                    :label="surveyAnswersLabel"
                    color="primary"
                    append-icon="mdi-account-question"
                    @keypress.enter="openQuestionnaireDialog"
                    @click="openQuestionnaireDialog"
                    @click:append="openQuestionnaireDialog">
                  </v-text-field> -->
                  <v-text-field
                        v-model="searchUserID"
                        :value="searchUserID"
                        label="User ID"
                        persistent-hint
                        class="mr-2"
                        required
                        clearable
                      ></v-text-field>
                  <v-row>
                    <v-text-field
                        v-model="searchUserName"
                        :value="searchUserName"
                        label="User name"
                        persistent-hint
                        class="mr-2"
                        required
                        clearable
                        style="margin-left: 10px;"
                      ></v-text-field>
                      <v-switch label="Exact match" v-model="this.toggleexactmatch" @change="exactMatchToggle($event)">
                      </v-switch>
                    </v-row>
                    <v-text-field
                        v-model="searchFirstname"
                        :value="searchFirstname"
                        label="First Name"
                        persistent-hint
                        class="mr-2"
                        required
                        clearable
                      ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md5 style="margin: 40px;">
                  <!-- <v-layout wrap>
                    <v-flex xs12 lg8>
                      <v-text-field
                        v-model="numLoginDays"
                        append-icon="search"
                        label="Number of Logins per Week"
                        hide-details
                        persistent-hint
                        clearable=""
                        type="number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 lg4>
                      <v-select
                        v-model="numLoginComparison"
                        :items="numLoginComparisonOption"
                        label="Comparison"
                        return-object
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-select
                    disabled
                    v-model="genderFilter"
                    :items="genders"
                    label="Gender"
                    required="!broadcast"
                    presistent-hint
                    return-object
                  ></v-select>
                  <v-row>
                    <v-col cols="6">
                      Groups
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-expansion-panels flat>
                      <v-expansion-panel :key="inGroupFilterPanel">
                        <v-expansion-panel-header>
                        In Group(s)
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-treeview
                            v-model="inGroupModel"
                            dense
                            selectable
                            selected-color="green"
                            item-disabled="locked"
                            :items="this.inGroupItems"
                          ></v-treeview>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel :key="notInGroupFilterPanel">
                        <v-expansion-panel-header>
                        Not In Group(s)
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-treeview
                            v-model="notInGroupModel"
                            dense
                            selectable
                            selected-color="red"
                            item-disabled="locked"
                            :items="this.notInGroupItems"
                          ></v-treeview>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-row>
                  <v-layout wrap>
                    <v-flex xs12 lg6>
                      <v-text-field
                        v-model="vaultMinAmount"
                        label="Vault Amount(min)"
                        persistent-hint
                        hide-details
                        clearable=""
                        type="number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 lg6>
                      <v-text-field
                        v-model="vaultMaxAmount"
                        label="Vault Amount(max)"
                        persistent-hint
                        hide-details
                        clearable=""
                        type="number"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 lg6>
                      <v-menu
                        v-model="vaultStartDateMenu"
                        :close-on-content-click="false"
                        :close-on-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="315px"
                        class="ma-0">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="displayVaultStartDate"
                            label="Vault Start Date"
                            persistent-hint
                            class="mr-2"
                            append-icon="event"
                            readonly
                            v-on="on"
                            required
                            @click="openVaultStartDate"
                          ></v-text-field>
                        </template>
                        <v-card class="ma-0" @keydown.esc="cancelVaultStartDate">
                          <v-container class="ma-0">
                            <v-row>
                              <v-col>
                                <v-date-picker
                                  v-model="vaultStartDate"
                                  color="primary"
                                  class="ma-0 pa-0"
                                  elevation="0"
                                  flat
                                >
                                </v-date-picker>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="1"></v-col>
                              <v-col cols="5">
                                <v-btn
                                  class="mr-1"
                                  outlined
                                  small
                                  fab
                                  color="red"
                                  @click="cancelVaultStartDate"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-btn
                                  class="ml-1 mr-0 mt-0"
                                  outlined
                                  small
                                  fab
                                  color="green"
                                  @click="confirmVaultStartDate"
                                >
                                  <v-icon>mdi-check-bold</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 lg6>
                      <v-menu
                            v-model="vaultEndDateMenu"
                            :close-on-content-click="false"
                            :close-on-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="315px"
                            class="ma-0"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="displayVaultEndDate"
                            label="Vault End Date"
                            persistent-hint
                            class="mr-2"
                            append-icon="event"
                            readonly
                            v-on="on"
                            required
                            @click="openVaultEndDate"
                          ></v-text-field>
                        </template>
                        <v-card class="ma-0" @keydown.esc="cancelVaultEndDate">
                          <v-container class="ma-0">
                            <v-row>
                              <v-col>
                                <v-date-picker
                                  v-model="vaultEndDate"
                                  color="primary"
                                  class="ma-0 pa-0"
                                  elevation="0"
                                  flat
                                >
                                </v-date-picker>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="1"></v-col>
                              <v-col cols="5">
                                <v-btn
                                  class="mr-1"
                                  outlined
                                  small
                                  fab
                                  color="red"
                                  @click="cancelVaultEndDate"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-btn
                                  class="ml-1 mr-0 mt-0"
                                  outlined
                                  small
                                  fab
                                  color="green"
                                  @click="confirmVaultEndDate"
                                >
                                  <v-icon>mdi-check-bold</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-menu>
                    </v-flex>
                  </v-layout> -->
                  <v-btn @click="submitFilters" style="margin-right: 15px;"> Submit </v-btn>
                  <v-btn @click="clearFilters"> Clear </v-btn>
                </v-flex>
              </v-row>
            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel :key="userSearchPanel">
        <v-expansion-panel-header>
          <div class="headline">{{ userSearchTitle }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <v-form>
            <v-container>
              <v-row justify="space-between">
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    clearable
                    @input="searchCleared()"
                  ></v-text-field>
                </v-flex>
                <v-icon
                  justify-end
                  :disabled="loadingUsers"
                  @click="refreshUsers(false, page=1)"
                  >mdi-cached</v-icon
                >
              </v-row>
              <v-layout> </v-layout>
            </v-container>
          </v-form> -->

          <v-card>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="filteredUsers"
              :search="search"
              :loading="loadingUsers"
              :loading-text="loadingText"
              :no-data-text="noDataText"
              item-key="userId"
              class="elevation-1"
              show-select
              @click:row="selectUser($event)"
              @toggle-select-all="selectAll($event)"
              disable-pagination
              hide-default-footer>
            </v-data-table>
            <div style="height: 80px; display: flex; align-items: center; justify-content: center;">
            <v-row class="pagination" justify="center" align="center">
            <v-btn v-if="page > 1" @click="setPage(page - 1)">
              Previous
            </v-btn>
            <div style="margin-right: 30px; margin-left: 30px;">
              {{ page }}
            </div>
            <v-btn v-if="page < totalPages" @click="setPage(page + 1)">
              Next
            </v-btn>
            <div style="margin-left: 30px; position: absolute; right: 0; bottom: 0;">
              Total Number of Pages: {{ totalPages }}
            </div>
            </v-row>
            </div>
          </v-card>
          <v-spacer></v-spacer>
        </v-expansion-panel-content>
      </v-expansion-panel>
    <!-- </v-expansion-panels>
    <v-expansion-panels v-model="userLoginHistoryPanelModel"> -->
      <v-expansion-panel :key="loginHistoryPanel">
        <v-expansion-panel-header>
          <div class="xs8" v-html="loginHistoryTitle">
            {{ loginHistoryTitle }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card text>
            <userLoginHistory
              @update:title="getLoginHistoryTitle()"
              :user="selected[0]"
              ref="loginHistory"
              class="tab"
            ></userLoginHistory>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div>
      <v-tabs
        slot="extension"
        v-model="model"
        color="blue"
        slider-color="yellow"
        :scrollable="true"
      >
        <v-tab :key="userDetailTab" v-if="!isMultiUserSelected">Details</v-tab>
        <v-tab :key="userJarTab" v-if="!isMultiUserSelected">Jars</v-tab>
        <v-tab :key="userVaultBalanceTab" v-if="!isMultiUserSelected">Vault Balance</v-tab>
        <v-tab :key="userBankAccountsTab" v-if="!isMultiUserSelected"
          >Bank Accounts</v-tab>
        <v-tab :key="userNotificationTab">Notifications</v-tab>
        <v-tab :key="userRewardTab" v-if="!isMultiUserSelected">Rewards</v-tab>
        <v-tab :key="userReportsTab" v-if="!isMultiUserSelected">Reports</v-tab>
        <v-tab :key="userRulesTab" v-if="!isMultiUserSelected">Rules</v-tab>
        <v-tab :key="userQuestionnaireTab">Questions</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-tabs-items v-model="model">
        <v-tab-item :key="userDetailTab" v-if="!isMultiUserSelected">
          <!-- <v-expansion-panels v-model="userLoginHistoryPanelModel">
            <v-expansion-panel :key="loginHistoryPanel">
              <template>
                <div slot="header" class="xs8" v-html="loginHistoryTitle">{{ loginHistoryTitle }}</div>
                <v-card flat>
                  <userLoginHistory @update:title="loginHistoryTitle = getLoginHistoryTitle()" :user="selected[0]" ref="loginHistory" class="tab"></userLoginHistory>
                </v-card>
              </template>
            </v-expansion-panel>
          </v-expansion-panels> -->
          <div>
            <template v-if="isUserSelected()">
              <v-container fluid grid-list-md>
                <v-flex xs48 sm48>
                  <v-card>
                    <v-container fluid grid-list-md>
                      <v-layout row wrap>
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userDetailSummary
                            v-if="isUserSelected()"
                            :user="selected[0]"
                            ref="userDetailSummaryRef"
                            :key="componentKey"
                          ></userDetailSummary>
                        </v-flex>
                        <!-- updated it to say userVaultSummaryRef instead of uservautsummaryref -->
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userVaultSummary
                            v-if="isUserSelected()"
                            :user="selected[0]"
                            ref="userVaultSummaryRef"
                          ></userVaultSummary>
                        </v-flex>
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userContestSummary
                            v-if="isUserSelected()"
                            :user="selected[0]"
                            ref="userContestSummaryRef"
                          ></userContestSummary>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-container>
            </template>
          </div>
        </v-tab-item>
        <v-tab-item :key="userJarTab" v-if="!isMultiUserSelected">
          <v-card flat v-if="isUserSelected()">
            <jars
              :user="selected[0]"
              ref="userJars"
              class="tab"
              :key="componentKey"
            ></jars>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userVaultBalanceTab" v-if="!isMultiUserSelected">
          <v-card flat v-if="isUserSelected()">
            <vaultBalance
              :user="selected[0]"
              ref="userVaultBalance"
              class="tab"
              :key="componentKey"
            ></vaultBalance>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userBankAccountsTab" v-if="!isMultiUserSelected">
          <v-card flat v-if="isUserSelected()">
            <userBankAccounts
              :user="selected[0]"
              ref="userBankAccounts"
              class="tab"
              :key="componentKey"
            ></userBankAccounts>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userNotificationTab">
          <v-card flat>
            <notifications
              :users="selected"
              :broadcastVisible="false"
              ref="notificationTab"
              class="tab"
              :key="componentKey"
            ></notifications>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userRewardTab" v-if="!isMultiUserSelected">
          <v-card flat>
            <rewards
              :user="selected[0]"
              ref="rewardTab"
              class="tab"
              :key="componentKey"
            ></rewards>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userReportsTab" v-if="!isMultiUserSelected">
          <v-card flat>
            <reports
              :user="selected[0]"
              ref="userReports"
              class="tab"
              :key="componentKey"
            ></reports>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userRulesTab" v-if="!isMultiUserSelected">
          <v-card flat>
            <rules
              :user="selected[0]"
              ref="rulesTab"
              class="tab"
              :key="componentKey"
            ></rules>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userQuestionnaireTab">
          <v-card flat>
            <questionnaires
              :users="selected"
              ref="questionnaireTab"
              class="tab"
              :key="componentKey"
            ></questionnaires>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import notifications from '@/components/Notifications.vue'
import questionnaires from '@/components/questionnaire/UserQuestionnaire.vue'
import questionAnswersFilter from '@/components/user/filters/QuestionAnswers.vue'
import jars from '@/components/UserJars.vue'
import reports from '@/components/UserReports.vue'
import rewards from '@/components/UserRewards.vue'
import rules from '@/components/UserRules.vue'
import userLoginHistory from '@/components/UserLoginHistory.vue'
import userVaultSummary from '@/components/UserVaultSummary.vue'
import userDetailSummary from '@/components/UserDetailSummary.vue'
import userContestSummary from '@/components/UserContestSummary.vue'
import userBankAccounts from '@/components/UserBankAccounts.vue'
import vaultBalance from '@/components/UserVaultBalance.vue'
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: ['auth'],

  data: () => ({
    // pageNumber: 0,
    loadingText: 'Loading... Please wait',
    noDataText: 'No user', // Can be used for error message when load failed
    model: null,
    toggleexactmatch: false,
    loginHistoryTitle: '',
    userSearchPanelModel: [0, 1],
    userSearchPanel: null,
    userFilterPanel: null,
    inGroupFilterPanel: null,
    notInGroupFilterPanel: null,
    userLoginHistoryPanelModel: null,
    loginHistoryPanel: null,
    userNotificationTab: null,
    userQuestionnaireTab: null,
    userJarTab: null,
    userDetailTab: null,
    userRewardTab: null,
    userRulesTab: null,
    userBankAccountsTab: null,
    userVaultBalanceTab: null,
    userReportsTab: null,
    loadingUsers: false,
    search: '',
    yearAgo: moment().subtract(1, 'year').format('YYYY-MM-DD'),
    numSavingGoals: '',
    searchUserName: '',
    searchUserID: '',
    searchFirstname: '',
    selectedJarCategories: [],
    savingGoalsName: '',
    numLoginDays: '',
    genderFilter: '',
    groupFilter: '',
    signOnDate: null,
    clearBoolean: false,
    originalSignOnDate: null,
    signOnDateMenu: null,
    signOnDateComparison: 'After',
    originalSignOnDateComparison: null,
    signOnDateComparisonOption: ['Equal', 'After'],
    displaySignOnDate: null,
    createdDate: null,
    createdDateMenu: null,
    originalCreatedDate: null,
    createdDateComparison: 'After',
    createdDateComparisonOption: ['Before', 'Equal', 'After'],
    originalCreatedDateComparison: null,
    displayCreatedDate: null,
    genders: ['male', 'female'],
    savingGoalComparison: 'Equal',
    savingGoalComparisonOption: ['Equal', 'More than', 'Less than'],
    numLoginComparison: 'Equal',
    numLoginComparisonOption: ['Equal', 'More than', 'Less than'],
    rppItems: [
      5,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    componentKey: 0,
    selected: [],
    selectedUsers: [],
    dialog: false,
    loginHistoryModel: false,
    headers: [
      {
        text: 'User ID',
        align: 'left',
        sortable: true,
        value: 'userId'
      },
      { text: 'Username', value: 'quberUserName' },
      { text: 'First Name', value: 'firstName' },
      { text: 'Last Name', value: 'lastName' },
      { text: 'Mobile Number', value: 'mobileNumber' },
      { text: 'Referrer Code', value: 'referralCode' },
      { text: 'Referrer Id', value: 'referredByUserId' },
      { text: 'Email Verified', value: 'emailVerified' }
    ],
    users: [],
    filteredUsers: [],
    editedIndex: -1,
    editedItem: {
      userId: '',
      quberUserName: 0,
      firstName: 0,
      lastName: 0,
      mobileNumber: 0
    },
    defaultItem: {
      userId: '',
      quberUserName: 0,
      firstName: 0,
      lastName: 0,
      mobileNumber: 0
    },
    shiftFlag: false,
    multiUserSelected: false,
    groups: [],
    inGroups: [],
    notInGroups: [],
    jarCategories: [],
    jarCategoryIds: [],
    jarCategoryNames: [],
    vaultMinAmount: null,
    vaultMaxAmount: null,
    vaultStartDate: null,
    originalVaultStartDate: null,
    vaultStartDateMenu: null,
    displayVaultStartDate: null,
    vaultEndDate: null,
    originalVaultEndDate: null,
    vaultEndDateMenu: null,
    displayVaultEndDate: null,
    notInGroupModel: null,
    inGroupModel: null,
    inGroupItems: [],
    notInGroupItems: [],
    selectedPlans: [],
    selectedNotInPlans: [],
    userQuestionnaireDialog: false,
    selectedInAnswerIds: [],
    selectedNotInAnswerIds: [],
    page: 1,
    pages: 1,
    totaluserpages: 0
  }),

  components: {
    notifications,
    questionAnswersFilter,
    questionnaires,
    rewards,
    userLoginHistory,
    jars,
    userVaultSummary,
    userDetailSummary,
    userContestSummary,
    userBankAccounts,
    vaultBalance,
    reports,
    rules
  },

  computed: {
    totalPages () {
      return Math.ceil(this.totaluserpages / this.rowsPerPage)
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    userSearchTitle () {
      if (this.selected.length > 1) {
        return this.selected.length + ' users selected'
      }
      return this.selected === undefined || this.selected.length < 1
        ? 'Select a User Below'
        : this.selected[0].userId +
            ' - ' +
            this.selected[0].firstName +
            ' ' +
            this.selected[0].lastName +
            ' (' +
            this.selected[0].quberUserName +
            ')'
    },
    isMultiUserSelected () {
      return this.selected.length > 1
    },
    surveyAnswersLabel () {
      var label = ''
      if (this.selectedInAnswerIds !== null && this.selectedInAnswerIds.length > 0) {
        label = this.selectedInAnswerIds.length + ' answered. '
      }
      if (this.selectedNotInAnswerIds !== null && this.selectedNotInAnswerIds.length > 0) {
        label += this.selectedNotInAnswerIds.length + ' not answered.'
      }
      if (label.length === 0) {
        label = 'Survey Answers'
      }
      return label
    },
    generateDisplaySignOnDate () {
      if (this.signOnDateComparison === 'Equal' && this.signOnDate != null) {
        return this.signOnDateComparison + ' to ' + this.signOnDate
      } else if (
        this.signOnDateComparison === 'After' &&
        this.signOnDate != null
      ) {
        return this.signOnDateComparison + ' ' + this.signOnDate
      } else {
        return ''
      }
    },
    generateDisplayCreatedDate () {
      if (this.createdDateComparison === 'Equal' && this.createdDate != null) {
        return this.createdDateComparison + ' to ' + this.createdDate
      } else if (this.createdDate != null) {
        return this.createdDateComparison + ' ' + this.createdDate
      } else {
        return ''
      }
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    inGroupModel (selection) {
      this.inGroupsChange(selection)
    },
    notInGroupModel (selection) {
      this.notInGroupsChange(selection)
    }
  },

  created () {
    this.initialize()
    this.laodGroups()
    this.loadCategories()
    this.refreshUsers(false, this.page)
  },

  methods: {
    setPage (page) {
      if (page !== this.page) {
        if (this.searchUserName === '' && this.searchFirstname === '') {
          this.page = page
          this.refreshUsers(false, this.page)
        } else if (this.searchUserName !== '' && this.searchUserName !== null) {
          this.page = page
          this.searchbyusername(this.page, this.searchUserName)
        } else {
          this.page = page
          this.searchbyfirstname(this.page, this.searchFirstname)
        }
      }
    },
    inGroupsChange (selections) {
      this.selectedPlans = []
      if (selections !== null) {
        selections.forEach((value, index, a) => {
          var planId = value.substring(4, value.length)
          this.selectedPlans.push(planId)
        })
      }
      this.notInGroupItems.forEach((v1, n1, a1) => {
        v1.children.forEach((v2, n2, a2) => {
          this.lockChild(v2, selections)
        })
        this.checkParentLock(v1)
      })
    },
    notInGroupsChange (selections) {
      this.selectedNotInPlans = []
      if (selections !== null) {
        selections.forEach((value, index, a) => {
          var planId = value.substring(4, value.length)
          this.selectedNotInPlans.push(planId)
        })
      }
      this.inGroupItems.forEach((v1, n1, a1) => {
        v1.children.forEach((v2, n2, a2) => {
          this.lockChild(v2, selections)
        })
        this.checkParentLock(v1)
      })
    },
    lockChild (child, selections) {
      if (selections !== null && child !== null) {
        if (selections.includes(child.id)) {
          child.locked = true
        } else {
          child.locked = false
        }
      }
    },
    checkParentLock (parent) {
      var allLocked = true
      if (parent !== null) {
        parent.children.forEach((v, n, a) => {
          if (v.locked === false) {
            allLocked = false
          }
        })
      }
      parent.locked = allLocked
    },
    async selectUser (a) {
      this.selected = [a]
      this.userSearchPanelModel = undefined
      this.componentKey++
      this.loginHistoryTitle = this.getLoginHistoryTitle()
    },
    isUserSelected () {
      return (
        this.selected !== undefined &&
        this.selected != null &&
        this.selected.length > 0
      )
    },
    searchCleared () {
      this.selected = []
      this.lastLogin = null
    },
    async initialize () {
      this.userSearchPanelModel = [0, 1]
      this.vaultStartDate = new Date()
      this.vaultStartDate.setDate(this.vaultStartDate.getDate() - 1)
      this.vaultStartDate = this.vaultStartDate.toISOString().substr(0, 10)
      this.displayVaultStartDate = this.vaultStartDate
      this.vaultEndDate = this.vaultStartDate
      this.displayVaultEndDate = this.vaultStartDate
    },
    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.users.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    hideHistory () {
      this.loginHistoryModel = false
    },
    openQuestionnaireDialog () {
      this.userQuestionnaireDialog = true
    },
    toggleHistory () {
      this.loginHistoryModel = !this.loginHistoryModel
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        this.users.push(this.editedItem)
      }
      this.close()
    },
    getLoginHistoryTitle () {
      if (
        this.$refs.loginHistory === undefined ||
        this.$refs.loginHistory === null
      ) { return '' }
      var title = ''
      var lastLogin = this.$refs.loginHistory.history[0]
      if (
        lastLogin === null ||
        lastLogin === undefined ||
        lastLogin.createdDate === undefined
      ) {
        if (this.selected != null && this.selected.length > 0) {
          title = 'User has not logged in'
        }
      } else {
        title =
          'Last logged into <b>Quber version ' +
          lastLogin.quberVersion +
          '</b> on <b>' +
          moment(String(lastLogin.createdDate)).format('MM/DD/YYYY hh:mm:ss') +
          '</b> using <b>' +
          lastLogin.deviceType +
          '</b> OS version <b>' +
          lastLogin.osVersion +
          '</b>'
      }
      this.loginHistoryTitle = title
      return title
    },
    async refreshUsers (loadAll, page) {
      this.loadingUsers = true
      this.selected = []
      this.users = []
      this.filteredUsers = []
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/all-users?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${page}`

      // if (!loadAll) {
      // endpoint = endpoint + `?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${page}`
      // }
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          this.users = value.data
          this.filteredUsers = value.data.users
          this.totaluserpages = value.data.totalRecords

          // Save users to session storage
          // if (loadAll) {
          //   sessionStorage.removeItem('users')
          // } else {
          //   sessionStorage.setItem('users', JSON.stringify(value.data))
          // }
        })
      this.loadingUsers = false
    },
    async laodGroups () {
      this.groups = []
      this.inGroups = []
      this.notInGroups = []

      this.loadingGroups = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups?details=true&all=true`

      var getResponse = await rh.default.get(endpoint, true).catch((e) => {
        this.errors.push(e)
        throw e
      })
      if (
        getResponse !== undefined &&
        getResponse.data !== undefined &&
        getResponse.data.length > 0
      ) {
        this.convertGroupPlansToTreeViewItems(getResponse.data)
        this.groups = getResponse.data
      }
      this.loadingGroups = false
    },
    async loadCategories () {
      this.jarCategories = []

      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/wishlists/getCategories`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          this.jarCategories = value.data.map(
            ({ categoryId, categoryName }) => ({ categoryId, categoryName })
          )
        })
    },
    async filterUsersByNumSavingGoals () {
      // Parameters
      // Merchant Wishlist category name
      var endpoint
      if (this.savingGoalComparison === 'Equal') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/user/getUsersByNumSavingGoals?number=${this.numSavingGoals}&comparator=0`
      } else if (this.savingGoalComparison === 'Less than') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/user/getUsersByNumSavingGoals?number=${this.numSavingGoals}&comparator=1`
      } else {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/user/getUsersByNumSavingGoals?number=${this.numSavingGoals}&comparator=2`
      }

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.users.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersByMerchantWishlistCategory () {
      // Parameters
      var selectedCategoryIds = this.selectedJarCategories.map(
        (i) => i.categoryId
      )

      // Merchant Wishlist category name
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/user/getUsersWithMerchantWishlistCategory?categoryIds=${selectedCategoryIds}`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersWithSavingGoalNameContaining () {
      // Parameters
      // savingGoalName
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/user/getUsersWithSavingGoalNameContaining?savingGoalName=${this.savingGoalsName}`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersWithSignOnDate () {
      // Parameters
      // userLoginDate (yyyy-MM-dd)
      var endpoint
      if (this.signOnDateComparison === 'After') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/login-history-date-after?userLoginDate=${this.signOnDate}`
      } else if (this.signOnDateComparison === 'Equal') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/login-history-date-equal?userLoginDate=${this.signOnDate}`
      }

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersByVaultAmountAndDates () {
      var endpoint
      var allParams = null

      if (this.vaultMinAmount !== null) {
        if (allParams === null) {
          allParams = `?lowerBalance=${this.vaultMinAmount}`
        } else {
          allParams = `${allParams}&lowerBalance=${this.vaultMinAmount}`
        }
      }
      if (this.vaultMaxAmount !== null) {
        if (allParams === null) {
          allParams = `?upperBalance=${this.vaultMaxAmount}`
        } else {
          allParams = `${allParams}&upperBalance=${this.vaultMaxAmount}`
        }
      }
      if (this.vaultStartDate !== null) {
        if (allParams === null) {
          allParams = `?startDate=${this.vaultStartDate}`
        } else {
          allParams = `${allParams}&startDate=${this.vaultStartDate}`
        }
      }
      if (this.vaultEndDate !== null) {
        if (allParams === null) {
          allParams = `?endDate=${this.vaultEndDate}`
        } else {
          allParams = `${allParams}&endDate=${this.vaultEndDate}`
        }
      }
      if (allParams === null) {
        return
      }
      endpoint = `${process.env.VUE_APP_QUBER_SERVICE_FUNDS_XFER}/vault/balances-in-date-range${allParams}`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    openSignOnDate () {
      this.originalSignOnDate = this.signOnDate
      this.originalSignOnDateComparison = this.signOnDateComparison
      if (this.signOnDate == null) this.signOnDate = new Date().toISOString().substr(0, 10)
    },
    cancelSignOnDate () {
      this.signOnDateMenu = false
      this.signOnDate = this.originalSignOnDate
      this.signOnDateComparison = this.originalSignOnDateComparison
    },
    confirmSignOnDate () {
      this.signOnDateMenu = false
      if (this.signOnDateComparison === 'Equal' && this.signOnDate != null) {
        this.displaySignOnDate = this.signOnDateComparison + ' to ' + this.signOnDate
      } else if (this.signOnDate != null) {
        this.displaySignOnDate = this.signOnDateComparison + ' ' + this.signOnDate
      } else {
        this.displaySignOnDate = ''
      }
    },
    async filterUsersWithCreatedDate () {
      if (this.loadingUsers) {
        this.filteredUsers = this.filteredUsers.filter((i) => {
          var d = i.createdDate.split('T')[0]
          if (this.createdDateComparison === 'After') {
            return this.createdDate < d
          } else if (this.createdDateComparison === 'Before') {
            return this.createdDate > d
          } else if (this.createdDateComparison === 'Equal') {
            return this.createdDate === d
          }
        })
      }
    },
    openCreatedDate () {
      this.originalCreatedDate = this.createdDate
      this.originalCreatedDateComparison = this.createdDateComparison
      if (this.createdDate == null) this.createdDate = new Date().toISOString().substr(0, 10)
    },
    cancelCreatedDate () {
      this.createdDateMenu = false
      this.createdDate = this.originalCreatedDate
      this.createdDateComparison = this.originalCreatedDateComparison
    },
    confirmCreatedDate () {
      this.createdDateMenu = false
      if (this.createdDateComparison === 'Equal' && this.createdDate != null) {
        this.displayCreatedDate = this.createdDateComparison + ' to ' + this.createdDate
      } else if (this.createdDate != null) {
        this.displayCreatedDate = this.createdDateComparison + ' ' + this.createdDate
      } else {
        this.displayCreatedDate = ''
      }
    },
    openVaultStartDate () {
      this.originalVaultStartDate = this.vaultStartDate
      if (this.vaultStartDate === null) this.vaultStartDate = new Date().toISOString().substr(0, 10)
    },
    cancelVaultStartDate () {
      this.vaultStartDateMenu = false
      this.vaultStartDate = this.originalVaultStartDate
    },
    confirmVaultStartDate () {
      this.vaultStartDateMenu = false
      this.displayVaultStartDate = this.vaultStartDate
    },
    openVaultEndDate () {
      this.originalVaultEndDate = this.vaultEndDate
      if (this.vaultEndDate === null) this.vaultEndDate = new Date().toISOString().substr(0, 10)
    },
    cancelVaultEndDate () {
      this.vaultEndDateMenu = false
      this.vaultEndDate = this.originalVaultEndDate
    },
    confirmVaultEndDate () {
      this.vaultEndDateMenu = false
      this.displayVaultEndDate = this.vaultEndDate
    },
    async filterUsersWithNumLogin () {
      // Parameters
      // numberOfDays (default=84 days(12 weeks)), comparator(0=equal, 1=more-than, 2=less-than), numLogins
      var endpoint
      var days = 84
      if (this.numLoginComparison === 'Equal') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/num-logins-past-days?numberOfDays=${days}&comparator=0&numLogins=${this.numLoginDays}`
      } else if (this.numLoginComparison === 'Less than') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/num-logins-past-days?numberOfDays=${days}&comparator=1&numLogins=${this.numLoginDays}`
      } else if (this.numLoginComparison === 'More than') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/num-logins-past-days?numberOfDays=${days}&comparator=2&numLogins=${this.numLoginDays}`
      }

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersByGender () {
      var endpoint
      // Parameters
      // gender (0=male, 1=female)
      if (this.genderFilter === 'male') {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/user-with-gender?gender=0`
      } else {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/user-with-gender?gender=1`
      }

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersByPlan () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/users-from-plans?planIds=${this.selectedPlans}`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersNotInPlan () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/users-from-plans?planIds=${this.selectedNotInPlans}`
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return !value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersBySurveyAnswer () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRE}/questionnaires/users-from-answers?answerIds=${this.selectedInAnswerIds}`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return value.data.includes(i.userId)
            })
          }
        })
    },
    async filterUsersByNotSurveyAnswer () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRE}/questionnaires/users-from-answers?answerIds=${this.selectedNotInAnswerIds}`
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          if (this.loadingUsers) {
            this.filteredUsers = this.filteredUsers.filter((i) => {
              return !value.data.includes(i.userId)
            })
          }
        })
    },
    questionAnswersCancel () {
      this.userQuestionnaireDialog = false
    },
    questionAnswersSubmit (inAnswersp, notInAnswersp, inIds, notInIds) {
      this.userQuestionnaireDialog = false
      this.selectedInAnswerIds = JSON.parse(inIds)
      this.selectedNotInAnswerIds = JSON.parse(notInIds)
    },
    async submitFilters () {
      try {
        if (this.loadingUsers) {
          // prevent multiple submit
          return
        }
        this.loadingUsers = true
        this.loadingText = 'Loading... Please wait'
        this.noDataText = 'No user'
        // this.filteredUsers = this.users
        var criteriaUsed = true
        if (this.numSavingGoals !== '') {
          criteriaUsed = true
          await this.filterUsersByNumSavingGoals()
        }
        if (
          this.selectedJarCategories !== '' &&
          this.selectedJarCategories.length > 0
        ) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersByMerchantWishlistCategory()
        }
        if (this.savingGoalsName !== '') {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersWithSavingGoalNameContaining()
        }
        if (this.signOnDate != null && this.signOnDateComparison != null) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersWithSignOnDate()
        }
        if (this.createdDate != null && this.createdDateComparison != null) {
          criteriaUsed = true
          this.clearBoolean = true
          await this.filterUsersWithCreatedDate()
        }
        if (this.numLoginDays !== '') {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersWithNumLogin()
        }
        if (this.genderFilter !== '') {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersByGender()
        }
        if (this.selectedPlans !== null && this.selectedPlans.length > 0) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersByPlan()
        }
        if (this.selectedNotInPlans !== null && this.selectedNotInPlans.length > 0) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersNotInPlan()
        }
        if (this.selectedInAnswerIds !== null && this.selectedInAnswerIds.length > 0) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersBySurveyAnswer()
        }
        if (this.selectedNotInAnswerIds !== null && this.selectedNotInAnswerIds.length > 0) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersByNotSurveyAnswer()
        }
        if (this.vaultMinAmount !== null || this.vaultMaxAmount !== null) {
          this.clearBoolean = true
          criteriaUsed = true
          await this.filterUsersByVaultAmountAndDates()
        }
        if (this.searchUserName !== null && this.searchUserName !== '' && (this.searchUserID === null || this.searchUserID === '')) {
          this.clearBoolean = true
          criteriaUsed = true
          this.page = 1
          await this.searchbyusername(this.page, this.searchUserName)
        }
        if (this.searchUserID !== null && this.searchUserID !== '') {
          this.clearBoolean = true
          criteriaUsed = true
          this.page = 1
          await this.searchbyuserID(this.page, this.searchUserID)
        }
        if (this.searchFirstname !== null && this.searchFirstname !== '' && (this.searchUserID === null || this.searchUserID === '')) {
          this.clearBoolean = true
          criteriaUsed = true
          this.page = 1
          await this.searchbyfirstname(this.page, this.searchFirstname)
        }
        if (!criteriaUsed) {
          this.page = 1
          await this.refreshUsers(false, this.page)
        }
        this.loadingUsers = false
      } catch (e) {
        this.filteredUsers = []
        this.loadingUsers = false
        this.noDataText =
          'Failed to load users with filters, click submit to try again. ' // Show error
      }
    },
    clearFilters () {
      if ((this.numSavingGoals !== '' || (this.selectedJarCategories !== '' && this.selectedJarCategories.length > 0) || this.savingGoalsName !== '' || (this.signOnDate != null && this.signOnDateComparison != null) || (this.createdDate != null && this.createdDateComparison != null) || this.numLoginDays !== '' || this.genderFilter !== '' || (this.selectedPlans !== null && this.selectedPlans.length > 0) || (this.selectedNotInPlans !== null && this.selectedNotInPlans.length > 0) || (this.selectedInAnswerIds !== null && this.selectedInAnswerIds.length > 0) || (this.selectedNotInAnswerIds !== null && this.selectedNotInAnswerIds.length > 0) || this.searchUserName !== '' || this.searchUserID !== '') || this.clearBoolean === true) {
        this.loadingUsers = true
        this.page = 1
        this.clearBoolean = false
        this.loadingText = 'Loading... Please wait'
        this.refreshUsers(false, this.page)
      }
      this.noDataText = 'No user'
      this.loadingText = ''
      this.numSavingGoals = ''
      this.savingGoalComparison = 'After'
      this.selectedJarCategories = []
      this.savingGoalsName = ''
      this.signOnDate = null
      this.signOnDateComparison = 'After'
      this.displaySignOnDate = null
      this.createdDate = null
      this.createdDateComparison = 'After'
      this.displayCreatedDate = null
      this.numLoginDays = ''
      this.genderFilter = ''
      this.selectedPlans = []
      this.selectedNotInPlans = []
      this.notInGroups = this.groups
      this.inGroups = this.groups
      // this.filteredUsers = this.users
      // this.loadingUsers = false
      this.vaultStartDate = new Date()
      this.vaultStartDate.setDate(this.vaultStartDate.getDate() - 1)
      this.vaultStartDate = this.vaultStartDate.toISOString().substr(0, 10)
      this.displayVaultStartDate = this.vaultStartDate
      this.vaultEndDate = this.vaultStartDate
      this.displayVaultEndDate = this.vaultStartDate
      this.searchUserName = ''
      this.searchUserID = ''
      this.searchFirstname = ''
      this.vaultMinAmount = null
      this.vaultMaxAmount = null
      this.selectedPlans = null
      this.selectedNotInPlans = null
      this.inGroupModel = []
      this.notInGroupModel = []
      this.selectedInAnswerIds = []
      this.selectedNotInAnswerIds = []
      this.page = 1
      this.toggleexactmatch = false
      // this.loadingUsers = false
    },
    selectAll (a) {
      if (a.value) {
        this.selected = this.filteredUsers
      } else {
        this.selected = []
      }
    },
    convertGroupPlansToTreeViewItems (groupPlans) {
      this.notInGroupItems = this.convertToTreeView(groupPlans)
      this.inGroupItems = this.convertToTreeView(groupPlans)
    },
    convertToTreeView (groupPlans) {
      var convertedGroups = []
      if (groupPlans !== null) {
        groupPlans.forEach((group, index, a) => {
          var plans = []
          if (group.plans !== null && group.plans !== undefined) {
            group.plans.forEach((plan, index, a2) => {
              var newPlan = {
                id: 'plan' + plan.id,
                name: plan.name,
                locked: false
              }
              plans.push(newPlan)
            })
          }
          if (plans !== null && plans.length !== 0) {
            var newGroup = {
              id: 'group' + group.id,
              name: group.name,
              locked: false,
              children: plans
            }

            convertedGroups.push(newGroup)
          }
        })
        return convertedGroups
      } else {
        return null
      }
    },
    async exactMatchToggle (a) {
      this.toggleexactmatch = a
    },
    async searchbyusername (pages, username) {
      this.loadingUsers = true
      this.selected = []
      this.users = []
      this.filteredUsers = []
      if (this.toggleexactmatch === true) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/all-users?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${pages}&username=${username}&exactMatch=${true}&onlyActive=true`
      } else {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/all-users?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${pages}&username=${username}&exactMatch=${false}&onlyActive=true`
      }

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          this.users = value.data.users
          this.filteredUsers = value.data.users
          this.totaluserpages = value.data.totalRecords
        })
      this.loadingUsers = false
    },
    async searchbyuserID (page, userid) {
      this.loadingUsers = true
      this.selected = []
      this.users = []
      this.filteredUsers = []
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/all-users?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${page}&exactMatch=${false}&userId=${userid}&onlyActive=true`
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          this.users = value.data.users
          this.filteredUsers = value.data.users
          this.totaluserpages = value.data.totalRecords
        })
      this.loadingUsers = false
    },
    async searchbyfirstname (page, firstname) {
      this.loadingUsers = true
      this.selected = []
      this.users = []
      this.filteredUsers = []
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/all-users?sortBy=userId&pageSize=${this.rowsPerPage}&pageNumber=${page}&firstName=${firstname}`
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
          this.users = value.data
          this.filteredUsers = value.data.users
          this.totaluserpages = value.data.totalRecords
        })
      this.loadingUsers = false
    }
  }
}

</script>
